// DS: C25A
import _extends from "@swc/helpers/src/_extends.mjs";
import React, { useContext } from 'react';
import FolderDropdownDesktop from './FolderDropdownDesktop';
import FolderDropdownMobileV3 from './FolderDropdownMobileV3';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
const FolderDropdown = (props)=>{
    const isMobile = useContext(MobileContext);
    if (isMobile) {
        return /*#__PURE__*/ React.createElement(FolderDropdownMobileV3, _extends({}, props));
    }
    return /*#__PURE__*/ React.createElement(FolderDropdownDesktop, _extends({}, props));
};
export default FolderDropdown;
